import { createReduxEnhancer } from '@sentry/react';

export const sentryReduxEnhancer = createReduxEnhancer({
  attachReduxState: false,
  actionTransformer: (action) => ({
    type: action.type,
    // drop payload to avoid sending data updates in every breadcrumb
  }),
  // our redux state is large, never send it to Sentry
  stateTransformer: () => null,
});

export default function getReduxSentryMiddleware() {
  return [sentryReduxEnhancer];
}
